const sobProcessor=(element)=>
{
let assembledElement =""
if (element["Severity_(mMRC_Scale)"] !== "")
    {
    assembledElement += ` mMRC scale ${element["Severity_(mMRC_Scale)"].slice(0,1)} (${element["Severity_(mMRC_Scale)"].slice(3)})`
    }
assembledElement += " shortness of breath"

if (element["Orthopnoea"] !== "")
    {
    assembledElement += (element["Orthopnoea"] === "Yes" ? " and orthopnoea " : " without orthopnoea")
    }

if (element["Frequency"] !== "")
    {
    assembledElement += ` ${element["Frequency"].toLowerCase()}`
    }

if (element["Present_for_several:"] !== "")
    {
    assembledElement += ` for several ${element["Present_for_several:"].toLowerCase()}`
    }

if (element["Any_precipitating_factors:"] !== "")
    {
    assembledElement += ` precipitated by ${element["Any_precipitating_factors:"] }`
    }


return (assembledElement)
}

export default sobProcessor